var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("custom-callout", { staticClass: "provider-proposal-callout" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-10" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "legend" }, [
              _vm._v("Número de Propuesta:")
            ]),
            _c("div", {
              staticClass: "font-weight-normal text-black",
              domProps: { textContent: _vm._s(_vm.data.proposalNumber) }
            })
          ]),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "legend" }, [
              _vm._v("Tipo de Proveedor:")
            ]),
            _c("div", {
              staticClass: "font-weight-normal text-black",
              domProps: { textContent: _vm._s(_vm.data.providerType) }
            })
          ]),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "legend" }, [
              _vm._v("Nombre del Proveedor:")
            ]),
            _c("div", {
              staticClass: "font-weight-normal text-black",
              domProps: { textContent: _vm._s(_vm.data.providerName) }
            })
          ]),
          _c(
            "div",
            { staticClass: "col-md-3" },
            [
              _c("div", { staticClass: "legend" }, [
                _vm._v("Servicio(s) a Ofrecer:")
              ]),
              _vm._l(_vm.data.services, function(item, index) {
                return _c("div", {
                  key: index,
                  staticClass: "font-weight-normal text-black",
                  domProps: { textContent: _vm._s(item.name) }
                })
              })
            ],
            2
          )
        ])
      ]),
      _c("div", { staticClass: "col-md-2" }, [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c("action-button", {
              staticClass: "mx-4 px-4 mt-1",
              attrs: {
                i: "fas fa-check",
                text: "Seleccionar",
                variant: "outline-success"
              },
              on: { click: _vm.onSelectHandler }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }